module.exports = __webpack_public_path__ + "static/media/start-buying-info2-en.b4e7f0ea.png";